import React from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { FLOWS_ENUM } from '../../common/enums';
import UpdateSuccessFields from '../../components/payment/common/success/UpdateSuccessFields';
import Success from '../../components/payment/common/success/Success';

const UpdateSuccess = () => {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.UPDATE_CERTIFICATE} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as="main"
        id="main-content"
        tabIndex={-1}
        colspan={24}
        aria-label="Update submitted"
      >
        <Content as="div">
          <Success
            successComponent={() => <UpdateSuccessFields />}
            flow={FLOWS_ENUM.UPDATE_CERTIFICATE}
          />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default UpdateSuccess;
